
import { computed, defineComponent, ref } from 'vue';
import { defineRule, Form } from 'vee-validate';
import { useProfileStore } from '../../store/profileStore';
import AppInput from '@/components/UI/AppInput.vue';
import AppSelect from '@/components/UI/AppSelect.vue';
import { useMainStore } from '@/store/mainStore';
import ValidationService from '@/services/ValidationService';

defineRule('isHandle', (value: string) => ValidationService.isHandle(value) || !value || 'Handle is not valid');
defineRule('maxLength', (value: string) => ValidationService.maxLength(value, 24) || 'Maximum length 24 characters');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppSelect,
  },
  setup() {
    const profileStore = useProfileStore();
    const mainStore = useMainStore();
    const formRef = ref();

    const schema = {
      handle: 'isHandle|maxLength',
    };

    const handle = computed({
      get() {
        return profileStore.bufferProfile.handle;
      },

      set(newHandle: string) {
        if (newHandle === '@') {
          profileStore.bufferProfile.handle = '';
          return;
        }
        const hasSnail = (newHandle[0] === '@');
        profileStore.bufferProfile.handle = hasSnail ? newHandle : `@${newHandle}`;
        formRef.value.setFieldValue('handle', profileStore.bufferProfile.handle);
      },
    });

    const handleSpeciality = computed({
      get() {
        return profileStore.bufferProfile.speciality?.value || null;
      },
      set(v) {
        profileStore.bufferProfile.speciality = {
          value: v as string,
        };
      },
    });

    function onEnter(input) {
      input.target.blur();
    }

    return {
      profileStore,
      mainStore,
      handle,
      handleSpeciality,
      schema,
      formRef,
      onEnter,
    };
  },
});
